import React,{useState} from 'react';

const MoreCredit = ({ onNext }) => {
  const [clickedButton, setClickedButton] = useState(null);
    const handleClick = (e) => {
      const buttonValue = e.target.value;
      setClickedButton(buttonValue);
      onNext(buttonValue);
    };
  return(
  <>
    <div className="qs-card__head"><h2 className="qs-card__title">Offered More Credit While Struggling?</h2></div>
    <div className="qs-card__body">
      <p className="qs-card__sub">Were you offered credit limit increases or promotional offers despite showing signs of financial difficulty (e.g. making only minimum payments, relying on credit for essentials)?</p>
      <div className="qs-actions">
        <button 
          type="button" 
          value={417}
          className={`qs-btn qs-btn--optn ${clickedButton == '417' ? 'btn-active' : ''}`} 
          onClick={handleClick}>
            Yes</button>
        <button 
          type="button" 
          value={418}
          className={`qs-btn qs-btn--optn ${clickedButton == '418' ? 'btn-active' : ''}`}
          onClick={handleClick}>
            No</button>
      </div>
    </div>
  </>
);
};

export default MoreCredit;
